import React, { useMemo, useState } from "react";

import styles from "./styles.module.css";
import DefaultProfileImage from "./../../assets/images/codeville/gallery/data-not-found.png";
import DataNotFoundImage from "./../../assets/images/codeville/gallery/data-not-found.png";

import graduates_2022 from "./../../assets/data/graduates-2022.json";
import graduates_2023 from "./../../assets/data/graduates-2023.json";
import graduates_2024 from "./../../assets/data/graduates-2024.json";

const CodeVillePastGraduatesPage = () => {
  // Tab styles
  const active_tab = {
    background: "linear-gradient(273.75deg, #e13f29 -1.55%, #fb7a68 -1.54%, #ec1840 104.27%)",
    color: "#eeeeee",
  };

  // Data
  const graduation_data = {
    2022: graduates_2022,
    2023: graduates_2023,
    2024: graduates_2024,
  };

  const [graduationYear, setGraduationYear] = useState("2024"); // default to 2024

  const graduates = useMemo(() => {
    return graduation_data[graduationYear] ?? null;
  }, [graduationYear]);

  return (
    <section className={styles.pastGraduates}>
      <div className={styles.pastGraduates_header}>
        <span>The Ultimate MVP Of The Year</span>
        <h1>The Past Graduates</h1>
      </div>
      <div className={styles.pastGraduates_content}>
        <div className={styles.content_tabs}>
          <span style={graduationYear === "2022" ? active_tab : {}} onClick={() => setGraduationYear("2022")}>
            2022
          </span>
          <span style={graduationYear === "2023" ? active_tab : {}} onClick={() => setGraduationYear("2023")}>
            2023
          </span>
          <span style={graduationYear === "2024" ? active_tab : {}} onClick={() => setGraduationYear("2024")}>
            2024
          </span>
        </div>
        {graduates ? (
          <div className={styles.pastGraduates_list}>
            {graduates.map((graduate, index) => (
              <GraduateContainer graduate={graduate} key={index} />
            ))}
          </div>
        ) : (
          <div className={styles.listNotFound}>
            <div className={styles.listNotFound_imageContainer}>
              <img loading="eager" src={DataNotFoundImage} />
            </div>
            <p>Gallery will be uploaded soon</p>
          </div>
        )}
      </div>
    </section>
  );
};

const GraduateContainer = ({ graduate }) => {
  const learningPaths = {
    game_dev: "Game Development",
    web_dev: "Web Development",
  };

  const graduateImage = useMemo(() => {
    return graduate.image;
  }, [graduate]);

  return (
    <div className={styles.pastGraduates_listItem}>
      <div className={styles.pastGraduates_listItem_imageContainer}>
        <img
          loading="eager"
          src={graduateImage}
          onError={(evt) => {
            evt.target.src = DefaultProfileImage;
            evt.onerror = null;
          }}
        />
      </div>
      <div className={styles.pastGraduates_listItem_contentContainer}>
        <h3>
          {graduate.first_name} {graduate.last_name}
        </h3>
        {graduate.learning_path && <p>{learningPaths[graduate.learning_path]}</p>}
        <p>{graduate.school_name ?? "School not provided"}</p>
        <span>{graduate.age ? `${graduate.age} years old` : "Age not provided"}</span>
      </div>
    </div>
  );
};

export { CodeVillePastGraduatesPage };
